import { gql } from "@apollo/client";

export default gql`
  mutation syncWithHrisMutation($organizationId: Int!) {
    syncWithHris(organizationId: $organizationId) {
      organization {
        id
        directorySync {
          id
          state
          type
          name
          lastSyncStart
          lastSyncEnd
        }
      }
    }
  }
`;
